import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { RequestDto } from './dto/RequestDto';

/**
 * Подтверждение контакта ключём из письма
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/Contacts/86f78d2d8df3b6daa4b5e1b360d98e5f
 * */
export const confirmEmail = (params: RequestDto): IRequest => ({
    uri: '/v1/contacts/confirm-email',
    method: 'POST',
    withAuth: true,
    withProvider: true,
    body: JSON.stringify(params),
});
